import type { Pixel, Rectangle } from "@pdfking/renderer-api"

export type ImageArray = Rectangle<Pixel> & {
  readonly data: Uint8Array
}
